import React, { createContext, useContext, useState } from 'react'

export interface BreadcrumbItem {
  label: string
  to?: string
  copyText?: string
}

interface LayoutContextData {
  showSidebar: boolean
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>
  showFipe: boolean
  setShowFipe: React.Dispatch<React.SetStateAction<boolean>>
  showAddressModal: boolean
  setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>
  breadcrumbs: BreadcrumbItem[]
  setBreadcrumbs: React.Dispatch<React.SetStateAction<BreadcrumbItem[]>>
}

export const LayoutContext = createContext<LayoutContextData>(
  {} as LayoutContextData
)

export const LayoutProvider: React.FC = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(true)
  const [showFipe, setShowFipe] = useState(false)
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([])

  return (
    <LayoutContext.Provider
      value={{
        showSidebar,
        setShowSidebar,
        showFipe,
        setShowFipe,
        showAddressModal,
        setShowAddressModal,
        breadcrumbs,
        setBreadcrumbs
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function useLayoutContext() {
  return useContext(LayoutContext)
}
